import { netSuiteConstants } from 'modules/common/constants';
import { domain } from 'modules/data';

export const isNetSuiteIntegrationCode = (
    integrationCode?: domain.IntegrationCode | null
): integrationCode is domain.NetSuiteIntegrationCodeType => {
    return Boolean(integrationCode && netSuiteConstants.netSuiteIntegrationCodes.includes(integrationCode));
};
